import { NgModule } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';

import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDrawerContainer, MatSidenavModule, } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { 
  MatDialogActions, 
  MatDialogClose, 
  MatDialogModule, 
  MatDialogTitle,
 } from '@angular/material/dialog';

const modules = [
  MatInputModule,
  MatIconModule,
  MatDrawerContainer,
  MatSidenavModule,
  MatToolbarModule,
  MatMenuModule,
  MatCardModule,
  MatListModule,
  MatButtonModule,
  MatTooltipModule,
  ClipboardModule,
  MatDialogActions, 
  MatDialogClose, 
  MatDialogModule, 
  MatDialogTitle
 
];

@NgModule({
  declarations: [],
  imports: modules,
  exports: modules,
  providers: [provideNativeDateAdapter()]
})
export class MaterialModule { }
